import { h } from 'vue'

const Heading = (props) => {
 return h('h1', {}, props.text)
}

Heading.props = ['text']

export default Heading